module.exports = __webpack_public_path__ + "static/img/3.c6c5b25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/empresas/3.png
// module id = cR2m
// module chunks = 0